var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "ma-0",
      attrs: { flat: "", fab: _vm.fab, small: "", color: "accent" },
      on: {
        click: function($event) {
          _vm.showDialog = true
        }
      }
    },
    [
      _c("v-icon", [_vm._v("headset_mic")]),
      _vm._v(" "),
      !_vm.fab ? [_vm._v("\n     Contact info\n  ")] : _vm._e(),
      _vm._v(" "),
      _vm.vendorDispatcher
        ? _c(
            "v-dialog",
            {
              attrs: { lazy: "", "max-width": "500" },
              model: {
                value: _vm.showDialog,
                callback: function($$v) {
                  _vm.showDialog = $$v
                },
                expression: "showDialog"
              }
            },
            [
              _c(
                "v-card",
                { class: { "pa-4": !_vm.$vuetify.breakpoint.smAndDown } },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { extended: "", dense: "" } },
                        [
                          _c("v-icon", { attrs: { color: "accent" } }, [
                            _vm._v("headset_mic")
                          ]),
                          _vm._v(" "),
                          _c("v-toolbar-title", [
                            _vm._v(_vm._s(_vm.vendorDispatcher.name))
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { slot: "extension" }, slot: "extension" },
                            [
                              _c(
                                "v-list-tile",
                                { staticClass: "pl-2" },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile-sub-title",
                                        { staticClass: "font-italic" },
                                        [
                                          _vm._v(
                                            "\n                  Dispatcher Contact Info\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer", { staticClass: "mb-3" }),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { attrs: { "pa-0": "", flat: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              readonly: !_vm.hasOfficePerm,
                              label: "Name"
                            },
                            model: {
                              value: _vm.name,
                              callback: function($$v) {
                                _vm.name = $$v
                              },
                              expression: "name"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              readonly: !_vm.hasOfficePerm,
                              label: "Email"
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              readonly: !_vm.hasOfficePerm,
                              label: "Phone (for SMS Texts)"
                            },
                            model: {
                              value: _vm.phone,
                              callback: function($$v) {
                                _vm.phone = $$v
                              },
                              expression: "phone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasOfficePerm
                        ? _c(
                            "v-card-actions",
                            { staticClass: "align-right" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "accent",
                                    loading: _vm.loadingBtn,
                                    flat: "",
                                    large: "",
                                    outline: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.showDialog = false
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-2",
                                      attrs: { large: "" }
                                    },
                                    [_vm._v("cancel")]
                                  ),
                                  _vm._v("\n            Cancel\n          ")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "accent",
                                    loading: _vm.loadingBtn,
                                    large: ""
                                  },
                                  on: { click: _vm.save }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-2",
                                      attrs: { large: "" }
                                    },
                                    [_vm._v("save")]
                                  ),
                                  _vm._v("\n            Save\n          ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e69fbb1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e69fbb1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qb/DispatcherInfo.vue
// module id = null
// module chunks = 